<div class="label-selected">
    <mat-checkbox color="primary" [checked]="labelSelected" (change)="onLabelSelected()" [disabled]="false" (click)="$event.stopPropagation()">
    </mat-checkbox>

    <div
        class="label-selected-container"
        [ngStyle]="{
            'background-color': getLabelTransparentBackgroundColor(),
            'border-color': label.color,
        }">
        <div class="label-selected-container-text">{{ label.displayName }}</div>
    </div>

    <div class="edit-label" *ngIf="isCustomLabel" (click)="editLabelClick()" [matTooltip]="!isOperator ? 'Only Operators can edit labels' : ''">
        <img src="assets/images/common/edit.svg" />
    </div>
</div>
